/* eslint-disable */
import React, { useEffect, useState } from 'react';
import SvgFacebook from '../../../assets/static/img/facebook.svg';
import SvgInstagram from '../../../assets/static/img/instagram.svg';
import SvgLinkedin from '../../../assets/static/img/linkedin.svg';
import SvgTwitter from '../../../assets/static/img/twitter.svg';
import styles from './Exhibitor.module.scss';
import s from '../../../components/Header/Header.module.scss';
import { A, T, O, M } from 'TOMA';
import Carousel from 'components/Carousel/Carousel';
import { ExhibitorRepository } from '../../../services/Exhibitor/Exhibitor.repository';
import { CodificationRepository } from '../../../services/Codification/Codification.repository';
import { EventRepository } from 'services/Event/Event.repository';
import { useParams } from 'react-router-dom';
import BreadCrumb from '../../../components/BreadCrumb/BreadCrumb';

interface Codification {
  code: string;
  topic: string;
  topicCode: string;
  label: string;
  filter: string;
}

interface ProductRest {
  id: string;
  name: string;
  photo_uuid: string;
  photo_extension: string;
}

interface ExhibitorRest {
  id: number;
  nom_societe: string;
  email_societe: string;
  site_web: string;
  twitter: string;
  instagram: string;
  linkedin: string;
  facebook: string;
  hall: string;
  stand: string;
  raison_sociale: string;
  showroom: number;

  adresse_postale: string;
  code_postal: string;
  ville: string;
  pays: string;
  tel_societe: string;
  type_entreprise: string;
  taille_domaine: string;
  production_annuelle: string;
  pourcentage_export: string;
  pays_export: string;
  pays_import: string;
  description_en: string;

  contact_revendeur_firstname: string;
  contact_revendeur_lastname: string;
  contact_revendeur_port: string;
  contact_revendeur_tel: string;
  contact_revendeur_email: string;

  logo_uuid: string;
  logo_extension: string;

  showroom_logo_uuid: string;
  showroom_logo_extension: string;

  media_1_uuid: string;
  media_1_extension: string;

  media_2_uuid: string;
  media_2_extension: string;

  media_3_uuid: string;
  media_3_extension: string;

  media_4_uuid: string;
  media_4_extension: string;

  media_5_uuid: string;
  media_5_extension: string;
  youtube_video: string;
}

interface Img {
  url: string;
  width: number;
  height: number;
}

interface Exhibitor {
  id: number;
  nom_societe: string;
  raison_sociale: string;
  email_societe: string;
  site_web: string;
  twitter: string;
  instagram: string;
  linkedin: string;
  facebook: string;
  showroom: number;
  hall: string;
  stand: string;
  adresse_postale: string;
  code_postal: string;
  ville: string;
  pays: string;
  tel_societe: string;
  type_entreprise: string;
  taille_domaine: string;
  production_annuelle: string;
  pourcentage_export: string;
  pays_export: string;
  pays_import: string;
  contact_revendeur_firstname: string;
  contact_revendeur_lastname: string;
  contact_revendeur_port: string;
  contact_revendeur_tel: string;
  contact_revendeur_email: string;
  description_en: string;
  logo: Img | null;
  galerie: Img[];
  youtube_video: string;
  showroom_logo: Img | null;
}

interface Data {
  exhibitor: Exhibitor | null;
  otherProduct:
    | {
        id: string;
        name: string;
        photo: { url: string; width: number; height: number } | null;
      }[]
    | null;
}

function getCodif(
  codifications: Codification[],
  topicCode: string,
  multiple?: boolean
): string {
  if (!codifications) return '';

  if (multiple) {
    const codifs = topicCode?.split(';');
    return codifs
      ?.map((tc) => codifications.find((e) => e.topicCode === tc)?.label)
      .sort()
      .join(', ');
  }

  return codifications.find((e) => e.topicCode === topicCode)?.label || '';
}

export default function Exhibitor(): JSX.Element {
  // const { setModalContent } = useModal();
  const [exhibitor, setExhibitor] = useState<Exhibitor | null>(null);
  const [codifications, setCodifications] = useState<Codification[]>([]);
  const [event, setEvent] = useState<any>(null);
  const [entreprise1, setEntreprise1] = useState<Array<{ value: string }>>([]);
  const [entreprise2, setEntreprise2] = useState<
    Array<{ label: string; value: string }>
  >([]);
  const [contact, setContact] = useState<
    Array<{ label: string; value: string }>
  >([]);
  const [otherProduct, setOtherProduct] = useState<Data['otherProduct'] | null>(
    null
  );

  const exhibitorRepo = new ExhibitorRepository();
  const codificationRepo = new CodificationRepository();
  const eventRepo = new EventRepository();

  const { slug, eid: exhibitorSlug } = useParams();

  useEffect(() => {
    codificationRepo.search().then((data: Codification[]) => {
      setCodifications(data);
    });

    eventRepo.getPublicEventBySlug(slug ?? '').then((data) => {
      const eventData = Array.isArray(data) ? data[0] : data;
      setEvent({
        ...eventData,
        logo:
          eventData.company_logo_uuid && process.env.REACT_APP_API_URL
            ? `${process.env.REACT_APP_API_URL}/storage/uploads/640/${eventData.company_logo_uuid}.${eventData.company_logo_extension}`
            : null,
      });
    });
  }, []);

  useEffect(() => {
    exhibitorRepo
      .findEventExhibitorById(slug ?? '', exhibitorSlug ?? '')
      .then(async (data: any) => {
        const logo = {
          url: data.logo_uuid
            ? `${process.env.REACT_APP_API_URL}/storage/uploads/640/${data.logo_uuid}.${data.logo_extension}`
            : '',
          width: 640,
          height: 480,
        }
        const galerie = [];
        const media1 =  {
          url: data.media_1_uuid
            ? `${process.env.REACT_APP_API_URL}/storage/uploads/640/${data.media_1_uuid}.${data.media_1_extension}`
            : '',
          width: 640,
          height: 480,
        }
        if (media1) galerie.push(media1);
        const media2 = {
          url: data.media_2_uuid
            ? `${process.env.REACT_APP_API_URL}/storage/uploads/640/${data.media_2_uuid}.${data.media_2_extension}`
            : '',
          width: 640,
          height: 480,
        }
        if (media2) galerie.push(media2);
        const media3 = {
          url: data.media_3_uuid
            ? `${process.env.REACT_APP_API_URL}/storage/uploads/640/${data.media_3_uuid}.${data.media_3_extension}`
            : '', 
        }
        if (media3) galerie.push(media3);
        const media4 = {
          url: data.media_4_uuid
            ? `${process.env.REACT_APP_API_URL}/storage/uploads/640/${data.media_4_uuid}.${data.media_4_extension}`
            : '',
          width: 640,
          height: 480,
        }
        if (media4) galerie.push(media4);
        const media5 = {
          url: data.media_5_uuid
            ? `${process.env.REACT_APP_API_URL}/storage/uploads/640/${data.media_5_uuid}.${data.media_5_extension}`
            : '',
          width: 640,
          height: 480,
        }
        if (media5) galerie.push(media5);

        setExhibitor({
          ...data,
          youtube_video: data.youtube_video || '',
          type_entreprise: getCodif(codifications, data.type_entreprise),
          pourcentage_export: getCodif(codifications, data.pourcentage_export),
          pays_export: getCodif(codifications, data.pays_export, true) || '',
          pays_import: getCodif(codifications, data.pays_import, true) || '',
          logo: logo,
          galerie: galerie,
        });
      });

    exhibitorRepo
      .products(slug ?? '', exhibitorSlug ?? '')
      .then((data: any) => {
        const products = data.map((product: ProductRest) => {
          const photo = product.photo_uuid
            ? {
                url: `${process.env.REACT_APP_API_URL}/storage/uploads/640/${product.photo_uuid}.${product.photo_extension}`,
                width: 640,
                height: 480,
              }
            : null;
          return {
            id: product.id,
            name: product.name,
            photo: photo,
          };
        });
        setOtherProduct(products);
      });
  }, [codifications]);

  useEffect(() => {
    setEntreprise1(
      [
        { value: exhibitor?.adresse_postale },
        { value: exhibitor?.code_postal },
        { value: exhibitor?.ville },
        { value: exhibitor?.pays },
        { value: exhibitor?.tel_societe },
        { value: exhibitor?.email_societe },
        { value: exhibitor?.site_web },
      ].filter((e): e is { value: string } => Boolean(e.value))
    );

    setEntreprise2(
      [
        { label: 'Type of company', value: exhibitor?.type_entreprise },
        { label: 'Size of Estate (ha)', value: exhibitor?.taille_domaine },
        {
          label: 'Annual Production (number of bottles)',
          value: exhibitor?.production_annuelle,
        },
        {
          label: 'Percentage of Export sales',
          value: exhibitor?.pourcentage_export,
        },
        { label: 'Your export markets', value: exhibitor?.pays_export },
        {
          label: 'Plans for export development',
          value: exhibitor?.pays_import,
        },
      ].filter((e): e is { label: string; value: string } => Boolean(e.value))
    );

    setContact([
      { label: 'Name', value: exhibitor?.contact_revendeur_firstname ?? '' },
      { label: 'Surname', value: exhibitor?.contact_revendeur_lastname ?? '' },
      {
        label: 'Cellphone',
        value: exhibitor?.contact_revendeur_port ?? '',
      },
      { label: 'Phone', value: exhibitor?.contact_revendeur_tel ?? '' },
      { label: 'E-mail', value: exhibitor?.contact_revendeur_email ?? '' },
    ]);
  }, [exhibitor]);

  const middleContact = Math.ceil(contact.length / 2);
  const contact1 = contact.splice(0, middleContact);
  const contact2 = contact.splice(-middleContact);

  const changeURL = (link: string) => {
    const pattern = /(?:v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = link.match(pattern);
    return match ? 'https://www.youtube.com/embed/' + match[1] : null;
  };

  if (!exhibitor || exhibitor.id === undefined) {
    return <div>Loading...</div>;
  }

  const BASE_PATH = window.location.pathname.split('/')[1];

  return (
    <>
      {event && (
        <div style={{ backgroundColor: event.color || '#000000' }}>
          <T.Block>
            <T.Container>
              <T.Flex halign="space-between" py="40" gap={4}>
                <T.Col>
                  <>
                    <T.Block my="10">
                      <A.Image
                        className="hidden"
                        src={event.logo || ''}
                        height="40"
                        width="auto"
                      />
                    </T.Block>
                    <A.Text color="white" mb="10" fontSize="24" fw="bold">
                      {event.name}
                    </A.Text>
                    <A.Text color="white" mb="10" fontSize="18">
                      {event.subtitle}
                    </A.Text>
                    <div className={s.Header__line}></div>

                    <T.Block mt="15">
                      <A.Text color="white" fontSize="18">
                        <T.Flex className="flex" gap={1}>
                          <div>
                            <A.Icon icon="calendar2-week-fill" color="white" />
                          </div>
                          <div>
                            Du {event?.date} au {event?.date_of_the_end}
                          </div>
                          <div>
                            <A.Icon icon="geo-fill" color="white" />
                          </div>
                          <div>
                            {event.city}, {event.country}
                          </div>
                        </T.Flex>
                      </A.Text>
                    </T.Block>
                  </>
                </T.Col>
              </T.Flex>
            </T.Container>
          </T.Block>
        </div>
      )}
      <div className={styles.Exhibitor}>
        <BreadCrumb
          breadCrumb={[
            // {
            //   icon: null,
            //   href: '/' + BASE_PATH + '/preview/events',
            //   label: 'Events',
            //   isCurrent: false,
            // },
            {
              icon: null,
              href: undefined,
              label: event ? event.name : 'Event',
              isCurrent: true,
            },
            {
              icon: null,
              href: '/' + BASE_PATH + '/preview/events/' + slug + '/exhibitors',
              label: 'List Of Exhibitors',
              isCurrent: false,
            },
            {
              icon: null,
              href: '/' + BASE_PATH + '/preview/events/' + slug + '/products',
              label: 'List Of Products',
              isCurrent: false,
            },
            // {
            //   icon: null,
            //   href: undefined,
            //   label: exhibitor?.raison_sociale || 'Exhibitor',
            //   isCurrent: true,
            // },
          ]}
        />
        <div className={styles.Exhibitor__content}>
          <div className={styles.Exhibitor__content__first}>
            <div className={styles.Exhibitor__mob}>
              <h1 className={styles.Exhibitor__mob__title}>
                {exhibitor?.nom_societe}
              </h1>
            </div>
            <div className={styles.Exhibitor__logo}>
              {exhibitor?.logo && (
                <img
                  src={exhibitor?.logo.url}
                  alt=""
                  width={exhibitor?.logo.width}
                  height={exhibitor?.logo.height}
                  className={styles.Exhibitor__logo__img}
                />
              )}
            </div>
            {!!exhibitor?.youtube_video && (
              <div className={styles.Exhibitor__youtube_block}>
                <iframe
                  src={changeURL(exhibitor?.youtube_video) ?? ''}
                  className={styles.Exhibitor__youtube_video}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            )}
            {!!exhibitor && exhibitor.galerie && exhibitor?.galerie.length && (
              <>
                <h2 className={styles.Exhibitor__subtitle}>Gallery</h2>
                <Carousel
                  direction="horizontal"
                  prevButton={(attr) => (
                    <button
                      type="button"
                      aria-label="Previous"
                      className={styles.Exhibitor__carousel__button__prev}
                      {...attr}
                    />
                  )}
                  nextButton={(attr) => (
                    <button
                      type="button"
                      aria-label="Next"
                      className={styles.Exhibitor__carousel__button__next}
                      {...attr}
                    />
                  )}
                >
                  <ul>
                    {exhibitor?.galerie.map(({ url, width, height }) =>
                      url ? (
                        <li key={url} className={styles.Exhibitor__galerie}>
                          <img
                            src={url}
                            alt=""
                            width={width}
                            height={height}
                            className={styles.Exhibitor__galerie__img}
                          />
                        </li>
                      ) : null
                    )}
                  </ul>
                </Carousel>
              </>
            )}
            <T.Flex halign="center" gap="2" px="20" mt="20">
              {exhibitor?.twitter && (
                <a href={exhibitor?.twitter} target="_blank" rel="noreferrer">
                  <img
                    src={SvgTwitter}
                    alt=""
                    className={styles.Exhibitor__social}
                  />
                </a>
              )}
              {exhibitor?.instagram && (
                <a href={exhibitor?.instagram} target="_blank" rel="noreferrer">
                  <img
                    src={SvgInstagram}
                    alt=""
                    className={styles.Exhibitor__social}
                  />
                </a>
              )}
              {exhibitor?.linkedin && (
                <a href={exhibitor?.linkedin} target="_blank" rel="noreferrer">
                  <img
                    src={SvgLinkedin}
                    alt=""
                    className={styles.Exhibitor__social}
                  />
                </a>
              )}
              {exhibitor?.facebook && (
                <a href={exhibitor?.facebook} target="_blank" rel="noreferrer">
                  <img
                    src={SvgFacebook}
                    alt=""
                    className={styles.Exhibitor__social}
                  />
                </a>
              )}
            </T.Flex>
          </div>

          <div className={styles.Exhibitor__content__last}>
            <div className={styles.Exhibitor__desk}>
              <h1 className={styles.Exhibitor__desk__title}>
                {exhibitor?.nom_societe}
              </h1>
              {!!(exhibitor?.stand && exhibitor?.hall) && (
                <a
                  href={`/floormap#${exhibitor?.hall}${exhibitor?.stand}`}
                  className={styles.Exhibitor__stand}
                >
                  Hall <b>{exhibitor?.hall}</b> Booth{' '}
                  <b>
                    {exhibitor?.hall}
                    {exhibitor?.stand}
                  </b>
                </a>
              )}
              {exhibitor?.showroom === 1 && exhibitor?.showroom_logo && (
                <div style={{ marginTop: '15px' }}>
                  <img
                    src={exhibitor?.showroom_logo.url}
                    alt=""
                    width={80}
                    height={80}
                  />
                </div>
              )}
            </div>

            <h2 className={styles.Exhibitor__subtitle}>
              {exhibitor?.raison_sociale}
            </h2>

            <A.Text color="grey-50" mb="25" fontSize="14">
              {exhibitor?.description_en}
            </A.Text>

            <div className={styles.Exhibitor__carousel}>
              <div className={styles.Exhibitor__carousel__group}>
                {entreprise1.map(({ value }, i, { length }) => (
                  <T.Flex halign="space-between" p="15" gap="1" key={value}>
                    <T.Col col="12">
                      <A.Text fontSize="16">{value}</A.Text>
                    </T.Col>
                  </T.Flex>
                ))}
              </div>
              <div>
                {entreprise2.map(({ label, value }, i, { length }) => (
                  <T.Flex halign="space-between" p="15" gap="1" key={label}>
                    {label ? (
                      <>
                        <T.Col col="6">
                          <A.Text fontSize="16" color="grey-60">
                            {label}
                          </A.Text>
                        </T.Col>
                        <T.Col col="6">
                          <A.Text fontSize="16">{value}</A.Text>
                        </T.Col>
                      </>
                    ) : (
                      <T.Col col="12">
                        <A.Text fontSize="16">{value}</A.Text>
                      </T.Col>
                    )}
                  </T.Flex>
                ))}
              </div>
            </div>

            <T.Block mb="50">
              <h2 className={styles.Exhibitor__subtitle}>Contact</h2>
              <div className={styles.Exhibitor__carousel}>
                <div className={styles.Exhibitor__carousel__group}>
                  {contact1.map(({ label, value }, i, { length }) => (
                    <T.Flex halign="space-between" p="15" gap="1" key={label}>
                      <T.Col col="6">
                        <A.Text fontSize="16" color="grey-60">
                          {label}
                        </A.Text>
                      </T.Col>
                      <T.Col col="6">
                        <A.Text fontSize="16">{value}</A.Text>
                      </T.Col>
                    </T.Flex>
                  ))}
                </div>
                <div>
                  {contact2.map(({ label, value }, i, { length }) => (
                    <T.Flex halign="space-between" p="15" gap="1" key={label}>
                      <T.Col col="6">
                        <A.Text fontSize="16" color="grey-60">
                          {label}
                        </A.Text>
                      </T.Col>
                      <T.Col col="6">
                        <A.Text fontSize="16">{value}</A.Text>
                      </T.Col>
                    </T.Flex>
                  ))}
                </div>
              </div>
            </T.Block>

            {otherProduct && otherProduct?.length > 1 && (
              <>
                <A.Title as="h3" fw={'normal'} mb="10">
                  Discover more products from this producer
                </A.Title>

                <Carousel
                  direction="horizontal"
                  prevButton={(attr) => (
                    <button
                      type="button"
                      aria-label="Previous"
                      className={styles.Exhibitor__carousel__button__prev}
                      {...attr}
                    />
                  )}
                  nextButton={(attr) => (
                    <button
                      type="button"
                      aria-label="Next"
                      className={styles.Exhibitor__carousel__button__next}
                      {...attr}
                    />
                  )}
                >
                  <ul>
                    {otherProduct?.map(({ id, name, photo }) => (
                      <li key={id} className={styles.Exhibitor__product}>
                        <a
                          href={`/${BASE_PATH}/preview/events/${slug}/products/${id}`}
                          className={styles.Exhibitor__product__content}
                          lang="en"
                        >
                          {photo && (
                            <img
                              src={photo.url}
                              alt=""
                              width={photo.width}
                              height={photo.height}
                              className={
                                styles.Exhibitor__product__content__img
                              }
                            />
                          )}
                          <A.Text as="p" fontSize="16" mt="10">
                            {name}
                          </A.Text>
                        </a>
                      </li>
                    ))}
                  </ul>
                </Carousel>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
